import React from "react";
import StoreForm from "./StoreForm";

const EditStoreModal = ({ store, onSubmit, onCancel, isLoading }) => {
  return (
    <div className="fixed inset-0 bg-black/50 flex items-center justify-center z-50 p-4">
      <StoreForm store={store} onSubmit={onSubmit} onCancel={onCancel} isLoading={isLoading} />
    </div>
  );
};

export default EditStoreModal;
